import React from 'react';

import './Footer.css';

export default function Footer() {
	return (
		<div className="footer">
			<div className="footer--inner-container">
				<div>&copy; PROGmasters - AngryNerds - 2019</div>
				<div>Contact: 06 1 438 971</div>
			</div>
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/common/Footer.jsx